import classNames from 'classnames';
import React, { useMemo } from 'react';
import ReactMarkdown from 'react-markdown';
import Slider from 'react-slick';
import {
	TemplateClassNames,
	VideosLayoutTypesBold,
	VideosLayoutTypesClassic,
	VideosLayoutTypesFun,
} from '../../../../types/template-layouts';
import { HomepageVideo, ModuleMap, PageModule, PageModuleType } from '../../../../types/working-model';
import { EIcon } from '../../../general-ui/icon/icon';
import { TypographyItem } from '../../../general-ui/typography-item/typography-item';
import { getStylingOverrides } from '../../utils';
import Video from './video';
import { ParamsProps } from '../../live-event';
import { useParams } from 'react-router';
import './videos.scss';
import { getTextValue } from '../../../../utils/utils';
interface VideoProps {
	module: PageModule;
	template: TemplateClassNames;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function PrevArrow(props: any): JSX.Element {
	const { className, style, onClick } = props;

	return (
		<div onClick={onClick} className={className} style={{ ...style }}>
			<EIcon name="keyboard-arrow-left" size="giant" />
		</div>
	);
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function NextArrow(props: any): JSX.Element {
	const { className, style, onClick } = props;

	return (
		<div onClick={onClick} className={className} style={{ ...style }}>
			<EIcon name="keyboard-arrow-right" size="giant" />
		</div>
	);
}

const SHARED_SLIDER_SETTINGS = {
	infinite: true,
	speed: 500,
	slidesToShow: 1,
	slidesToScroll: 1,
};

export const SINGLE_SLIDER_SETTINGS = {
	...SHARED_SLIDER_SETTINGS,
	dots: true,
};

export const MULTI_SLIDER_SETTINGS = {
	...SHARED_SLIDER_SETTINGS,
	dots: false,
	centerMode: false,
	variableWidth: true,
	arrows: false,
};

const Videos = React.forwardRef<HTMLDivElement, VideoProps>(({ module, template }, ref) => {
	const { language }: ParamsProps = useParams();
	const { content, styling_overrides, modules } = module;
	const layout_type = content?.layout_type || VideosLayoutTypesClassic.standard;
	const {
		backgroundColor,
		backgroundImg,
		customHeadingOverrides,
		titleOverrides,
		descriptionOverrides,
	} = getStylingOverrides(styling_overrides);

	const sliderSettings = useMemo(() => {
		const isVideoListPreview =
			layout_type === VideosLayoutTypesBold.ltr ||
			layout_type === VideosLayoutTypesClassic.ltr ||
			layout_type === VideosLayoutTypesFun.ltr;

		return isVideoListPreview
			? { ...MULTI_SLIDER_SETTINGS }
			: { ...SINGLE_SLIDER_SETTINGS };
	}, [layout_type]);

	const videos = modules;

	const { custom_heading, description, title } = getTextValue(content, language);

	return module.is_on && content && (
		<section
			id={ModuleMap[PageModuleType.videos]}
			className={classNames(
				'videos',
				`videos-${layout_type}`,
				template,
				backgroundColor
			)}
			ref={ref}
		>
			<div className="module-container" style={backgroundImg}>
				<div className="video-title-container">
					<TypographyItem className={classNames('evt-caption-1 video-custom-heading', customHeadingOverrides)} tagName="p">
						{custom_heading}
					</TypographyItem>
					<TypographyItem className={classNames('evt-heading-2 video-title', titleOverrides)} tagName="h2">
						{title}
					</TypographyItem>
					<TypographyItem className={classNames('evt-body-text-1 video-description', titleOverrides)} tagName="div">
						<ReactMarkdown source={description} className={classNames('video-description', descriptionOverrides)} />
					</TypographyItem>
				</div>
				{/* <img
							src={content.image || 'https://brandlive-upload.s3-us-west-2.amazonaws.com/uploads/17/6a32749f-4028-4905-adf4-34c120d428c1/Windmill.jpg'}
							alt=""
							width="375"
							height="300"
							aria-hidden="true"
					/> */}
				{/* <div className="video-slider">{renderVideo()}</div> */}

				{videos && videos.length ? (
					<div className="video-slider">
						<Slider
							{...sliderSettings}
							prevArrow={<PrevArrow />}
							nextArrow={<NextArrow />}
						>
							{videos.map((video: HomepageVideo) => (
								<Video
									key={video.source}
									video={video}
									multi={videos.length > 1}
									template={template}
									isMain={false}
								/>
							))}
						</Slider>
					</div>
				) : null}
			</div>
		</section>
	);
});

Videos.displayName = 'Videos';

export default Videos;
